import { BaseText, Button, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePermitStore } from 'stores/permitStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const UnsavedEditPermitConfirm: React.FC = () => {
  const { t } = useTranslation();
  const setUnsavedEditPermitAction = usePermitStore(
    (state) => state.setUnsavedEditPermitAction
  );

  const handleSave = () => {
    useUiStore.getState().setSheetModal('');
    setUnsavedEditPermitAction('save');
  };

  const handleDiscard = () => {
    useUiStore.getState().setSheetModal('');
    setUnsavedEditPermitAction('discard');
  };

  return (
    <StyledWrapper mb={0}>
      <StyledWrapper mb={40}>
        <BaseText
          center
          color={theme.colors.gray300}
          testID="unsaved-edit-permit-text">
          {t('vehicle.unsavedChanges.confirmText')}
        </BaseText>
      </StyledWrapper>
      <StyledWrapper mb={20}>
        <Button
          testID="unsaved-edit-permit-save"
          size="l"
          buttonType="secondary"
          text={t('button.saveChanges')}
          onPress={handleSave}
        />
      </StyledWrapper>
      <StyledWrapper mb={0}>
        <Button
          testID="unsaved-edit-permit-discard"
          size="l"
          buttonType="tertiary"
          text={t('button.discard')}
          onPress={handleDiscard}
        />
      </StyledWrapper>
    </StyledWrapper>
  );
};

export default UnsavedEditPermitConfirm;
